import React, { useCallback, useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Card, Spin, Pagination, Empty, Input, Breadcrumb, Select } from 'antd';
import { EditOutlined, ShareAltOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';
import style from './styles.module.css';
import Button from '../../../components/button';
import { ServiceCerca } from 'services/modulos/serviceCerca';

import CardUploadedItem from '../Components/CardUploadedItem';

import { Fence } from 'interfaces/fences';
import { useAuthData } from 'hooks/auth/useAuthData';
import { FenceSupesp, FenceSupespUpload } from 'interfaces/statistics';
import { ServiceEstatisticas } from 'services/modulos/serviceEstatisticas';
import { CIDADES_ARQUIVOS_SUPESP, FILE_TYPE_SUPESP } from 'utils/reutils';

const PAGE_SIZE = 5;

const { Option } = Select;
const { Search } = Input;

export interface stateProps {
  items: FenceSupesp[];
  valueSearched: string;
  currentPage: number;
  loading: boolean;
  total: number;
  allFences: Fence[];
}

export function PolygonsListSupesp() {
  const history = useHistory();
  const { data: dataAuth } = useAuthData();

  const { roles } = dataAuth || {};

  const [selectedCities, setSelectedCities] = useState<string[]>([]);
  const [selectedFileTypes, setSelectedFileTypes] = useState<string[]>([]);

  const [page, setPage] = useState({
    first: 0,
    last: PAGE_SIZE,
  });

  const [state, setState] = useState<stateProps>({
    items: [],
    valueSearched: '',
    currentPage: 1,
    loading: false,
    total: 0,
    allFences: [],
  });

  const updateState = useCallback((newProperties: any) => {
    setState(prev => ({ ...prev, ...newProperties }));
  }, []);

  const { items, valueSearched, currentPage, loading, total } = state;

  // const deleteItem = useCallback(
  //   async (id: string, nome: string) => {
  //     try {
  //       updateState({ loading: true });
  //     } catch (error) {
  //       toast.error(`Erro ao excluir cerca. Tente novamente.`);
  //     } finally {
  //       updateState({ loading: false });
  //     }
  //   },

  //   [updateState]
  // );

  const onSearch = useCallback(
    async (value: any) => {
      try {
        updateState({ loading: true, valueSearched: value });

        const response = await ServiceEstatisticas.get({
          cidades: [],
          tipoArquivos: [],
        });

        if (value.length) {
          setPage({
            first: 0,
            last: PAGE_SIZE,
          });
        } else {
          setPage(() => ({
            first: (currentPage - 1) * PAGE_SIZE,
            last: currentPage * PAGE_SIZE,
          }));
        }
        updateState({
          items: response || [],
          total: response.length || 0,
          loading: false,
        });
      } catch (error) {
        toast.error('Erro ao carregar cercas. Tente novamente.');
        console.error(error);
      }
    },
    [updateState, currentPage, valueSearched]
  );

  useEffect(() => {
    onSearch(valueSearched);
  }, []);

  const handleSearch = useCallback(
    (value: any) => {
      updateState({ valueSearched: value });
      if (currentPage === 1) {
        onSearch(value);
      } else {
        updateState({ currentPage: 1 });
      }
    },
    [currentPage]
  );

  return (
    <div>
      <Breadcrumb style={{ padding: '10px' }}>
        <Breadcrumb.Item>
          {/* @ts-expect-error Server Component */}
          <Link to="/">Página Inicial</Link>
        </Breadcrumb.Item>

        <Breadcrumb.Item>Estatísticas</Breadcrumb.Item>
      </Breadcrumb>

      <Card>
        <div className={style.header}>
          <div>
            <h2>Itens salvos</h2>
          </div>
          <div className={style.buttons}>
            {roles?.includes('ROLE_ROTAS_HISTORICO_CONEXAO') && (
              <Button
                onClick={() => history.push('/estatisticas-supesp/upload/')}
                type="button"
                buttonStyle="btn--secondary"
                icon={<ShareAltOutlined />}
              >
                Upload
              </Button>
            )}
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', gap: '4px' }}>
          <Search
            placeholder="Pesquise por nome"
            size="large"
            onSearch={handleSearch}
          />

          <Select
            value={selectedCities}
            onChange={e => setSelectedCities(e)}
            showSearch
            style={{
              width: 200,
            }}
            size="large"
            virtual={false}
            notFoundContent={null}
            mode="tags"
            showArrow
            // defaultValue={'Fortaleza'}
            // getPopupContainer={trigger => trigger.parentElement}
            placeholder="Cidade"
            filterOption={(input, option) => {
              return Boolean(
                option?.children &&
                  String(option.children || '')
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              );
            }}
          >
            {CIDADES_ARQUIVOS_SUPESP.map(city => (
              <Option key={city} value={city}>
                {city}
              </Option>
            ))}
          </Select>

          <Select
            value={selectedFileTypes}
            onChange={e => setSelectedFileTypes(e)}
            showSearch
            style={{
              width: 200,
            }}
            size="large"
            virtual={false}
            notFoundContent={null}
            mode="tags"
            showArrow
            // defaultValue={'Fortaleza'}
            // getPopupContainer={trigger => trigger.parentElement}
            placeholder="Tipos de arquivos"
            filterOption={(input, option) => {
              return Boolean(
                option?.children &&
                  String(option.children || '')
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              );
            }}
          >
            {FILE_TYPE_SUPESP.map(type => (
              <Option key={type} value={type}>
                {type}
              </Option>
            ))}
          </Select>
        </div>
        <Spin spinning={loading} tip="Carregando...">
          {items.length > 0 ? (
            !loading &&
            items
              .filter(item => {
                if (!item.nome.includes(valueSearched)) return false;
                if (
                  selectedCities.length &&
                  !selectedCities.includes(item.cidade)
                )
                  return false;
                if (
                  selectedFileTypes.length &&
                  !selectedFileTypes.includes(item.tipoArquivo)
                )
                  return false;
                return true;
              })
              .slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE)
              .map(item => {
                let points: number[][] = [];

                if (
                  item.tipoArquivo === 'CERCA' ||
                  item.tipoArquivo === 'ACE'
                ) {
                  points =
                    item.geom?.points?.map(point => [point.x, point.y]) || [];
                } else if (item.tipoArquivo === 'QUADRA') {
                  points =
                    item.geomLine?.coordinates?.map(point => [
                      point.x || 0,
                      point.y || 0,
                    ]) || [];
                } else if (item.tipoArquivo === 'CVLI') {
                  points = [[item.geomPoint?.y || 0, item.geomPoint?.x || 0]];
                }

                const feature: FenceSupespUpload = {
                  points,
                  nome: item.nome,
                  cidade: item.cidade,
                } as FenceSupespUpload;

                return (
                  <CardUploadedItem
                    id={item.id || ''}
                    key={item.id || ''}
                    nome={item.nome}
                    feature={feature}
                    // deleteItem={deleteItem}
                    system={false}
                    tipo={item.tipoArquivo || 'CERCA'}
                  />
                );
              })
          ) : (
            <Empty description="Arquivos não encontrados" />
          )}
          <Pagination
            style={{ textAlign: 'end', paddingTop: '15px' }}
            defaultCurrent={1}
            total={
              items?.filter(item => {
                if (!item.nome.includes(valueSearched)) return false;
                if (
                  selectedCities.length &&
                  !selectedCities.includes(item.cidade)
                )
                  return false;
                if (
                  selectedFileTypes.length &&
                  !selectedFileTypes.includes(item.tipoArquivo)
                )
                  return false;
                return true;
              }).length || 0
            }
            current={currentPage}
            pageSize={PAGE_SIZE}
            showSizeChanger={false}
            showTotal={total => `${total} itens`}
            onChange={pageChange => {
              updateState({ currentPage: pageChange });
            }}
          />
        </Spin>
        <br />
      </Card>
    </div>
  );
}
